<div class="flex-parent">
  <div class="login-form-div">
    <mat-icon class="really-big-icon icon-green pulse-icon" >check_circle</mat-icon>
    <div class="header">
      <h3 class="text-details">
        {{'externallogin.success' | translate}}
      </h3>
    </div>
    <div class="additional-options">
      <button class="login-link forgot-button" mat-flat-button color="accent" matTooltip="{{('loginForm.return' | translate)}}"  type="button" (click)="redirectToApp()">
        <mat-icon class="forgot-icon">reply</mat-icon>
        {{ ('loginForm.return' | translate)}}
      </button>
    </div>
  </div>
</div>
